export default function getDocumentScroll() {
    return (window.document.documentElement.scrollTop ||
        window.document.body.scrollTop ||
        0);
}
